
<app-vendor-about></app-vendor-about>


<app-botones-rapidos></app-botones-rapidos>

<app-register-new-familiar *ngIf="flagTitular"></app-register-new-familiar>

<!-- Modal de recomendación de app para afiliado específico -->
<div class="overlay-modal" *ngIf="showAppModal" [class.fade-in]="showAppModal">
    <div class="modal-content">
        <button class="close-btn" (click)="closeAppModal()">x</button>
        
        <div class="welcome-section">
            <h2 class="welcome-title">Afiliado</h2>
            <p class="welcome-text">
                Le recomendamos utilizar la aplicación móvil para una mejor experiencia y acceso rápido a sus servicios.
                Para obtenerla, haga click en el botón de descarga.
            </p>
        </div>
        
        <div class="action-section">
            <button class="btn-primary" (click)="redirectToAppStore()">
                Descargar aplicación
            </button>
        </div>
    </div>
</div>

<!-- TRAMITES -->
<!-- <div class="container">

    <br>
    <div class="section-title">
        <h3>{{ idioma | translate: "home.TRAMITES-TITULO" | async}} </h3>
        <p>{{ idioma | translate: "home.TRAMITES-DESCRIPCION" | async}} </p>
    </div>

    <app-ofertas-listar [flagViewTitle]="false" [highValue]="3"></app-ofertas-listar>

    <div class="col-lg-12 col-md-12">
        <div class="courses-info">
            <a routerLink="/tramites-disponibles" class="default-btn"><i class="flaticon-people"></i>{{ idioma | translate: "form.VER-TRAMITES-BTN" | async}} <span></span></a>
        </div>
    </div>
</div> -->
